import { EXPOSED_FIELD_TYPES } from "../";
import { clone } from "ramda";
// Only exported for testing purposes
export const formConfigFieldDef = [
    { key: "label", type: "text", label: "Label" },
    { key: "type", type: "options", label: "Type",
        defaultValue: "text",
        options: Object.entries(EXPOSED_FIELD_TYPES)
            .map(([key, value]) => ({ text: value.label, value: key })) },
    { key: "required", type: "yesno", label: "Required", defaultValue: true },
    { key: "sectionLevel", type: "options", label: "Section Level",
        condition: "type == 'section'",
        options: [{ text: "1", value: 1 }, { text: "2", value: 2 }, { text: "3", value: 3 }],
    },
    { key: "key", type: "text", label: "Field ID",
        defaultBinding: {
            field: "label",
            transform: "createUniqueKey"
        }
    },
    { key: "description", type: "text", longText: true, label: "Description" },
    { key: "agentContext", type: "text", longText: true, label: "Agent Context" },
    // {key: "unique", type: "yesno", label: "Unique"},
    { key: "longText", type: "yesno", label: "Long Text",
        description: "If enabled, the field will be a long text field",
        condition: "type == 'text'"
    },
    { key: "condition", type: "text", label: "Condition" },
    { key: "options", type: "composedList", label: "Options",
        condition: "type == 'options' || type == 'multipleOptions'",
        styles: {
            visibleFields: ["text"]
        },
        fields: [
            { key: "text", type: "text", label: "Text" },
            { key: "value", type: "text", label: "Value", defaultBinding: {
                    field: "text",
                    transform: "createUniqueKey"
                } }
        ] },
    // {key: "schedulingConfig", type: "composed", label: "Scheduling Config",
    //   condition: "type == 'scheduling'",
    //   fields: [
    //     {key: "variant", type: "options", label: "Variant", defaultValue: "calendar-widget",
    //       options: [{text: "Calendar Widget", value: "calendar-widget"}, {text: "Natural Language", value: "natural-language"}]},
    //   ]
    // },
    { key: "readOnly", type: "yesno", label: "Read Only", condition: "type == 'text' || type == 'options' || type == 'multipleOptions'" },
    { key: "styles", type: "composed", label: "Styles",
        fields: [
            { key: "layout", type: "options", label: "Layout",
                options: [{ text: "Select", value: "select" }, { text: "Block", value: "block" }] },
            { key: "colSpan", type: "options", label: "Column Span", description: "The number of columns to span the field in the form",
                options: [{ text: "1", value: 1 }, { text: "2", value: 2 }, { text: "3", value: 3 }, { text: "full", value: 'full' }] },
        ]
    }
];
export function buildFormConfigItself() {
    const config = {
        key: "form-builder",
        type: "form",
        description: "This is the form definition of a form builder that is used to build other forms, it is not a final form, it is a tool to define the form structure of other forms.",
        validationStrictness: "noValidations",
        fields: [
            {
                key: "label", type: "text", label: "Title"
            },
            {
                key: "key", type: "text", label: "Form ID",
                readOnly: true,
                defaultBinding: {
                    field: "label",
                    transform: "createUniqueKey"
                }
            },
            {
                key: "description", type: "text", label: "Description of what the Form Agent does", longText: true
            },
            {
                key: "configurations",
                type: "composed",
                label: "Configurations",
                fields: [
                    {
                        key: "alwaysShowReview", type: "yesno", label: "Always Show Review",
                        description: "If enabled, the Form Agent will always show the review step"
                    },
                    // {
                    //   key: "useGoogleDrive", type: "yesno", label: "Use Google Drive Integration",
                    //   description: "If enabled, the Form Agent will use Google Drive to deambiguate the form fields"
                    // },
                    {
                        key: "validationStrictness", type: "options", label: "Validation Strictness",
                        description: "The level of certainty and accuracy that we need from the Validation Agent.",
                        options: [
                            { text: "Strict", value: "strict", description: "There are always validations if there is ambiguos data." },
                            { text: "No Validations", value: "noValidations",
                                description: "There are no validations, the AI agent does its best to extract structured data." }
                        ],
                        defaultValue: "strict"
                    }
                ]
            },
            {
                key: "fields", type: "composedList", label: "Fields",
                styles: {
                    visibleFields: ["label", "type", "required"]
                },
                //TODO: We are explicitly supporting 2 levels of nested composed fields, that should be enough for most cases
                fields: [
                    ...clone(formConfigFieldDef),
                    {
                        key: "fields", type: "composedList", label: "Fields",
                        styles: {
                            visibleFields: ["label", "type", "required"],
                            colSpan: 2
                        },
                        options: { classicMode: { layout: "table" } },
                        condition: "type == 'composedList'",
                        fields: [...clone(formConfigFieldDef)]
                    }
                ]
            }
        ]
    };
    return config;
}
